import React from 'react'
import Assuarance from "./Assuarance";
import backGround  from '../../assets/img/background.png'


const Mission = () => {
  return (
    <div className='' 
    style={{backgroundImage: `url(${backGround})`}}>

    <section className='flex flex-col justify-center items-center'>
     <div className='text-center mb-20'>
       <h1 className='text-xl md:text-4xl font-bold text-white'>Our Mission</h1>
        {/* <img
          src='/assets/backGround.png'
          alt='testing'
        /> */}
     </div>

      <div className='flex flex-col items-center py-5'>
        <h1 className='text-3xl md:text-center font-bold text-white mb-16'>
            Amplifying Voices Through Innovation
        </h1>

        <p className='md:w-3/4 md:text-xl text-white indent-4'>
        OpenPolitica is at the forefront of integrating artificial 
        intelligence with democratic processes. Our mission is to bridge the gap 
        between citizens and policy-makers, ensuring every voice is heard and acted 
        upon. We strive to make AI a catalyst for democratic change.
        </p>
      </div>
    </section>
    <Assuarance/>
    </div>
  )
}

export default Mission